import { Container } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { AppDispatch } from '../../Store';
import AdView from '../../components/ui/AdView';
import { Ad_RefreshKey, BoardSearchListState, RiaBottomState } from '../../recoil/states';
import { asyncReqBoardJokeNextList } from '../../reducers/BoardJokeNextListReducer';
import CommonUtil from '../../utils/CommonUtil';
import BoardJokeNextList from '../BoardInfo/BoardJokeNextList';

const Index = () => {

    const setRiaBottomState = useSetRecoilState(RiaBottomState); // 하단 UI 랜더링 처리를 위해 사용되는 state
    const boardSearchListState = useRecoilValue(BoardSearchListState); // 검색 화면 페이징 처리를 위해 사용되는 state
    const ad_RefreshKey = useRecoilValue(Ad_RefreshKey); // 광고 UI 랜더링 처리를 위해 사용되는 state
    const dispatch = useDispatch<AppDispatch>();

    setRiaBottomState(rawState => ({ rawState, currPathName: window.location.pathname })); // 이전/다음 손가락 버튼 표시 요청

    useEffect(() => {
        getBoardJokeNextList();
    });

    /**
    * 하단 Masonry 레이아웃 목록 가져오기
    * 
    * @param
    * @returns
    */
    const getBoardJokeNextList = (): void => {

        const search_keyword: string = CommonUtil.getQuerystring("search_keyword", ""); // '게시판 고유번호' 파라메터 가져오기
        const page_size: number = parseInt(process.env.REACT_APP_BOARD_JOKE_NEXT_PAGE_SIZE as string, 10);
        const curr_page: number = boardSearchListState.currPage === 1 ?
            parseInt(CommonUtil.getQuerystring("curr_page", "1"), 10)
            : boardSearchListState.currPage;

        dispatch(asyncReqBoardJokeNextList({ page_size, curr_page, board_seq: "", search_keyword })); // 하단 Masonry 레이아웃 목록 가져오기
    }

    return (
        <Container fixed={true} maxWidth="md" sx={{ padding: "10px" }}>
            <AdView googleAdsense={{ rootid: "adsense_Ad_Web_Root_1", slot: "9182674614", height: CommonUtil.isMobileOs() ? 50 : 100 }}
                kakaoAdfit={{ rootid: "kakao_Ad_Web_Root_1", unit: "DAN-ghfGhrGorDYfcWd2", width: 320, height: 50 }}
                marginStyle="10px 0 0"
                refreshKey={ad_RefreshKey}
            />
            <BoardJokeNextList mode="AJS" />
        </Container>
    )
}

export default Index;
